import { Component, OnDestroy } from '@angular/core';
import { AppSecuredComponent } from 'src/app/app-secured/app-secured.component';
import { DialogService } from 'primeng/dynamicdialog';
import { BannerLocalService } from '../../services/local/banner.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styles: [
  ]
})

export class BannerComponent implements OnDestroy {
  subscription: Subscription;
  items: MenuItem[];

  constructor(
    public app: AppSecuredComponent,
    protected dialogService: DialogService,
    public bannerLocalService: BannerLocalService,
  ) {
    this.subscription = bannerLocalService.itemsHandler.subscribe(response => {
      this.items = response;
    });
  }
  ngOnDestroy(): void {
      if (this.subscription) {
          this.subscription.unsubscribe();
      }
  }
}
